// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__23RBh","content":"RecentSearches_content__i7yUZ"};